import { Search } from "@mui/icons-material";
import { Box, Checkbox } from "@mui/material";
import ContentNormal from "components/elements/ContentNormal";
import { AppContext } from "contexts/AppContext";
import { useMemo, useState, useEffect, useContext } from "react";
import FilterButton from "./FilterButton";
import { translate } from "utils/Translate";

export default function FilterSelect({
  label = "Filter",
  options = [],
  value = [],
  onApply,
  placeholder = "",
  enableSearch = false,
}) {
  const { styleGuide } = useContext(AppContext)
  const [search, setSearch] = useState("")
  const [draftValue, setDraftValue] = useState(value)

  useEffect(() => {
    setDraftValue(value);
  }, [value]);

  const filteredOptions = useMemo(() => {
    return options.filter((option) =>
      option.label.toLowerCase().includes(search.toLowerCase())
    );
  }, [options, search]);

  function toggleOption(optionValue) {
    setDraftValue((current) =>
      current.includes(optionValue)
        ? current.filter((v) => v !== optionValue)
        : [...current, optionValue]
    );
  }

  function handleApply() {
    onApply(draftValue)
  }

  function handleReset() {
    setDraftValue([])
    onApply([])
  }

  if(!options.length) {
    return null
  }

  return (
    <FilterButton label={label} onApply={handleApply} onReset={handleReset}>
      {enableSearch &&
        <Box
          display={'flex'}
          alignItems={'center'}
          backgroundColor={styleGuide.color3}
          border={'none'}
          borderRadius={'8px'}
          marginBottom={2}
          padding={'8px 10px'}
        >
          <Search sx={{color: styleGuide.color5}} />
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder={placeholder || translate('_SHOP_SEARCH_LABEL_', 'Søg')}
            style={{
              width: "100%",
              backgroundColor: styleGuide.color3,
              border: "none",
              outline: 'none'
            }}
          />
        </Box>
      }

      <Box style={{ maxHeight: 280, overflowY: "auto" }}>
        {filteredOptions.map((option) => (
          <Box key={option.value} display={'flex'} justifyContent={'space-between'} alignItems={'center'} paddingY={1} borderBottom={`1px solid ${styleGuide.color3}`}>
            <ContentNormal key={option.value}>
              {option.label}
            </ContentNormal>
            <Checkbox
              type="checkbox"
              checked={draftValue.includes(option.value)}
              onChange={() => toggleOption(option.value)}
              style={{color: draftValue.includes(option.value) ? styleGuide.color16 : ''}}
            />
          </Box>
        ))}

        {filteredOptions.length === 0 && (
          <Box padding={1} color={styleGuide.color4}>
            No options found
          </Box>
        )}
      </Box>
    </FilterButton>
  )
}